import React from 'react';
import { LandingTemplate } from '@/components/landing/landingTemplate';
import { GenerateLandingLinkService } from '@/services';
import { landingAiArtGeneratorConfig } from '@/data/landingConfig/landingAiArtGeneratorConfig';
import { AggregateSchema } from '../AggregateSchema';
import { schemaObject_AiArtGenerator } from './schemaObject';

interface Props {}
const AiArtGenerator: React.FC<Props> = () => {
	return (
		<>
			<AggregateSchema schema={schemaObject_AiArtGenerator} />
			<LandingTemplate
				data={landingAiArtGeneratorConfig}
				funnelLinkService={GenerateLandingLinkService.funnelAnimeGenerator()}
			/>
		</>
	);
};

export default AiArtGenerator;
